import React from 'react';
import type { AgentIconProps } from './AgentIconBase';

export default function REAgent({
  width = '100%',
  height = '100%',
  className = '',
}: AgentIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 150"
      width={width}
      height={height}
      className={className}
    >
      <circle fill="#0057a8" cx="75" cy="75" r="75" />
      <path
        fill="#fff"
        d="M99.57,80.9s0,.03,0,.05c0,13.58-11.02,24.6-24.62,24.6s-24.62-11.01-24.62-24.6c0-.02,0-.03,0-.05h-16.92v4.32c.06.93.65,1.7,1.6,1.84l9.15,1.38c.73,3.33,1.98,6.07,3.74,8.95l-5.64,7.63c-.72.98-.51,2.25.36,2.98l5.67,5.64c.78.75,1.82.77,2.69.11l7.64-5.84c2.85,1.8,5.68,3.01,8.94,3.81l1.23,9c.15,1.09,1.11,1.85,2.18,1.79h8.27c.79,0,1.77-.59,1.9-1.48l1.33-9.24c3.24-.85,6.02-2.01,8.99-3.71l7.71,5.72c.82.61,1.82.53,2.54-.15l5.85-5.86c.61-.76.84-1.74.23-2.59l-5.7-7.79c1.7-2.83,2.89-5.66,3.7-8.95l8.86-1.32c1.08-.16,1.87-.65,1.95-1.85v-4.39h-17.04Z"
      />
      <ellipse fill="#fff" cx="74.94" cy="39.44" rx="11.54" ry="11.94" />
      <path
        fill="#fff"
        d="M74.94,56.27c-13.6,0-24.62,11.02-24.62,24.62h49.25c0-13.6-11.02-24.62-24.62-24.62Z"
      />
    </svg>
  );
}
